import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import AddService, { AddServiceForm } from './AddService';
import { mockServices } from "../mockdata/services";

const EditService = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  // services en setServices via history/navigate state
  const state = window.history.state?.usr || {};
  const services = state.services || mockServices;
  const setServices = state.setServices || (()=>{});
  const service = services.find(x => String(x.id) === String(id));
  const [formData, setFormData] = useState(service ? { ...service } : null);
  const [isLoading, setIsLoading] = useState(false);
  const [deleted, setDeleted] = useState(false);

  if (!service) {
    return <div className="min-h-screen flex flex-col items-center justify-center">Dienst niet gevonden.</div>;
  }

  function handleInputChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }
  function handleImagesChange(images) {
    setFormData(prev => ({ ...prev, images }));
  }
  function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      alert('Wijzigingen opgeslagen! (mock)');
      navigate(-1);
    }, 500);
  }
  function handleDelete() {
    if (window.confirm('Weet je zeker dat je deze dienst wilt verwijderen?')) {
      setServices((prev) => prev.filter(x => String(x.id) !== String(id)));
      setTimeout(() => navigate('/profiel'), 300);
    }
  }
  useEffect(() => {
    if (deleted) navigate('/profiel');
  }, [deleted, navigate]);
  return (
    <div className="min-h-screen bg-elegant pb-24">
      <div className="max-w-2xl mx-auto pt-8">
        <h1 className="text-2xl font-serif text-center mb-6">Dienst bewerken</h1>
        {/* Afbeelding preview (centered) */}
        {formData?.images?.[0] && (
          <div className="flex justify-center mb-6">
            <img
              src={formData.images[0]}
              alt={formData.title || formData.name}
              className="w-full max-w-xs h-48 object-cover rounded-xl shadow"
              style={{border: '2px solid #f4ecd8'}}
            />
          </div>
        )}
        <AddServiceForm
          formData={formData}
          setFormData={setFormData}
          isLoading={isLoading}
          handleInputChange={handleInputChange}
          handleImagesChange={handleImagesChange}
          handleSubmit={handleSubmit}
          navigate={navigate}
          initialData={service}
        />
        {/* Gecentreerde button-row (ook mobiel) */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mt-10">
          <Button onClick={handleSubmit} disabled={isLoading} className="w-full sm:w-auto">Wijzigingen opslaan</Button>
          <Button variant="destructive" onClick={handleDelete} className="w-full sm:w-auto">Verwijderen</Button>
        </div>
      </div>
    </div>
  );
};

export default EditService;